export const MatchPropConst = {
  dos: 'DOS',
  memberName: 'Member Name',
  trip: 'Trip',
  los: 'LOS',
  signature: 'Signature',
  miles: 'Miles',
  vin: 'VIN',
  vehicleCode: 'Vehicle Code',
  driver: 'Driver',
  pickup: 'Pickup',
  dropOff: 'DropOff',
  company: 'Company'
};




// WEBPACK FOOTER //
// ./src/app/core/enums/match-prop.ts